import React from 'react';
import { ArrowLeftCircleIcon } from '@heroicons/react/24/solid';
import SmallButton from '../../SmallButton';
import Title from '../../Title';

interface Props {
  title: string;
  onBack?: () => void;
  primaryAction?: React.ReactNode;
}

export default function PageHeader({ title, onBack, primaryAction }: Props) {
  return (
    <>
      {onBack && (
        <section className="nav-status-bar">
          <div className="status-bar-content">
            <ArrowLeftCircleIcon width={20} height={20} />
            <SmallButton onClick={onBack}>Back</SmallButton>
          </div>
        </section>
      )}
      <div className="admin-page-header">
        <Title>{title}</Title>
        {primaryAction && (
          <div className="admin-page-header__action">{primaryAction}</div>
        )}
      </div>
    </>
  );
}
